<div class="customer-tax-estimates" *ngIf="publishedPlans && publishedPlans.length > 0">
  <div class="row" style="margin-bottom: 3rem">
    <div class="medium-2 columns">
      <label>
        <app-tpiq-select-dropdown [includeNone]="false" [setData]="publishedPlans" [setPlaceHolder]="'Select Plan'" [setSearchKey]="'planName'" [setValueKey]="'planId'" (onValueSelect)="setPlan($event)" [setDefaultValue]="currentPlanId"></app-tpiq-select-dropdown>
      </label>
    </div>
    <div class="medium-8 columns"></div>
    <div class="medium-2 columns tax-strategy">
      <span class="icons report-icon-header" style="margin-left: 20px;position: relative;top: 5px;" *ngIf="showProjection">
        <i class="icon ion-ios-cloud-download-outline" data-toggle="projection-download"></i>
        <div class="dropdown-pane pdf-export-dropdown" id="projection-download" data-dropdown data-hover="true" data-hover-pane="true" foundation>
          <div (click)="exportToPdf()" class="export-option">Export into pdf</div>
          <div (click)="exportToExcel()" class="export-option">Export into excel</div>
        </div>
      </span>
    </div>
  </div>
  <div class="row" *ngIf="showProjection">
    <div class="medium-12 columns" style="margin-bottom: 1rem;">
      <div class="row">
        <div class="column medium-6">
          <div class="row">
            <div class="medium-10 columns">
              <span>
                <label class="estimate-title">Prior Year Tax</label>
              </span>
            </div>
            <div class="medium-2 columns">
              <span>{{taxEstimates.priorYearTax | formatAmount:'$0,0'}}</span>
            </div>
          </div>
          <div class="row">
            <div class="medium-10 columns">
              <span>
                <label class="estimate-title">Prior Year Tax AGI</label>
              </span>
            </div>
            <div class="medium-2 columns">
              <span>{{taxEstimates.priorYearAGI | formatAmount:'$0,0'}}</span>
            </div>
          </div>
          <div class="row">
            <div class="medium-10 columns">
              <span>
                <label class="estimate-title">Current Year Tax</label>
              </span>
            </div>
            <div class="medium-2 columns">
              <span>{{taxEstimates.currentYearTax | formatAmount:'$0,0'}}</span>
            </div>
          </div>
          <div class="row">
            <div class="medium-10 columns">
              <span>
                <label class="estimate-title">Current Year Tax AGI</label>
              </span>
            </div>
            <div class="medium-2 columns">
              <span>{{taxEstimates.currentYearAGI | formatAmount:'$0,0'}}</span>
            </div>
          </div>
          <div class="row">
            <div class="medium-10 columns">
              <span>
                <label class="estimate-title">Filing Status</label>
              </span>
            </div>
            <div class="medium-2 columns">
              <span>{{taxEstimates.filingStatus}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="medium-12 columns" style="margin-bottom: 3rem;" *ngFor="let projection of projections">
      <div class="row">
        <div class="medium-12 columns" style="margin-bottom: 0.5rem;">
          <span class="projection-title bold">{{projection.projectionName}}</span>
        </div>
        <div class="column medium-6">
          <div class="row projection-item-row-wrap">
            <div class="medium-10 columns">
              <span *ngIf="projection.projectionName == 'Federal 1040 Tax Projection'">
                <label class="estimate-title">Safe Harbor Tax Due</label>
              </span>
              <span *ngIf="projection.projectionName == 'State Personal Tax Projection'">
                <label class="estimate-title">Prior Year Tax Due</label>
              </span>
            </div>
            <div class="medium-2 columns">
              <span *ngIf="projection.projectionName == 'Federal 1040 Tax Projection'">{{projection.safeHarbor | formatAmount:'$0,0'}}</span>
              <span *ngIf="projection.projectionName == 'State Personal Tax Projection'">{{projection.priorYearTaxDue | formatAmount:'$0,0'}}</span>
            </div>
          </div>
          <div class="row projection-item-row-wrap">
            <div class="medium-10 columns">
              <span *ngIf="projection.projectionName == 'Federal 1040 Tax Projection'">
                <label class="estimate-title">Current Year Expected Minimum Tax Due</label>
              </span>
              <span *ngIf="projection.projectionName != 'Federal 1040 Tax Projection'">
                <label class="estimate-title">Current Year Expected Tax Due</label>
              </span>
            </div>
            <div class="medium-2 columns">
              <span>{{projection.currentYearExpectedMinTaxDue | formatAmount:'$0,0'}}</span>
            </div>
          </div>
          <div class="row projection-item-row-wrap" *ngIf="projection.projectionName == 'Federal 1040 Tax Projection' || projection.projectionName == 'State Personal Tax Projection'">
            <div class="medium-10 columns">
              <span>
                <label class="estimate-title">Minimum Amount Due to IRS</label>
              </span>
            </div>
            <div class="medium-2 columns">
              <span>{{projection.minimumAmountDueToIRS | formatAmount:'$0,0'}}</span>
            </div>
          </div>
          <div class="row projection-item-row-wrap">
            <div class="medium-10 columns">
              <span>
                <label class="estimate-title">Over Payment Applied for PY</label>
              </span>
            </div>
            <div class="medium-2 columns">
              <span>{{projection.overPaymentAppliedForPY | formatAmount:'$0,0'}}</span>
            </div>
          </div>
          <div class="row projection-item-row-wrap" *ngIf="projection.projectionName == 'Federal 1040 Tax Projection' || projection.projectionName == 'State Personal Tax Projection'">
            <div class="medium-10 columns">
              <span>
                <label class="estimate-title">Estimated W-2 Withholding</label>
              </span>
            </div>
            <div class="medium-2 columns">
              <span>{{projection.estimatedW2WithHolding | formatAmount:'$0,0'}}</span>
            </div>
          </div>
        </div>
        <div class="column medium-6">
          <div class="row" style="padding-bottom: 15px;">
            <div class="column medium-12">
              <label>
                <span>
                  <label class="estimate-title">Note to client:</label>
                </span>
                <span>{{projection.notes}}</span>
              </label>
            </div>
          </div>
        </div>
        <div class="medium-12 columns">
          <div class="row projection-item-row-wrap" style="color: #878787;background-color: #E5E5E5;padding: 5px 0;" *ngIf="projection.projectionName == 'Federal 1040 Tax Projection' || projection.projectionName == 'State Personal Tax Projection'">
            <div class="column medium-3"></div>
            <div class="column medium-2"><span>Recommended</span></div>
            <div class="column medium-2"><span>Paid</span></div>
            <div class="column medium-2"><span>Paid Date</span></div>
            <div class="column medium-3"><span>Notes</span></div>
          </div>
          <div class="row projection-item-row-wrap" style="color: #878787;background-color: #E5E5E5;padding: 5px 0;" *ngIf="projection.projectionName == 'C-Corp Federal Tax Projection' || projection.projectionName == 'C-Corp State Tax Projection'">
            <div class="column medium-2"></div>
            <div class="column medium-2"><span>Due Date</span></div>
            <div class="column medium-2"><span>Recommended</span></div>
            <div class="column medium-2"><span>Paid</span></div>
            <div class="column medium-2"><span>Paid Date</span></div>
            <div class="column medium-2"><span>Notes</span></div>
          </div>
          <ng-template [ngIf]="projection.projectionName == 'Federal 1040 Tax Projection' || projection.projectionName == 'State Personal Tax Projection'">
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-3">
                  <label class="user-title title-adjust">Q1 Due 4/15</label>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter1.recommended | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter1.paid | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter1.paidDate}}</span>
                </div>
                <div class="column medium-3">
                  <span>{{projection.quarter1.notes}}</span>
                </div>
              </div>
            </div>
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-3">
                  <label class="user-title title-adjust">Q2 Due 6/15</label>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter2.recommended | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter2.paid | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter2.paidDate}}</span>
                </div>
                <div class="column medium-3">
                  <span>{{projection.quarter2.notes}}</span>
                </div>
              </div>
            </div>
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-3">
                  <label class="user-title title-adjust">Q3 Due 9/15</label>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter3.recommended | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter3.paid | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter3.paidDate}}</span>
                </div>
                <div class="column medium-3">
                  <span>{{projection.quarter3.notes}}</span>
                </div>
              </div>
            </div>
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-3">
                  <label *ngIf="projection.projectionName == 'Federal 1040 Tax Projection'" class="user-title title-adjust">Q4 Due 1/15</label>
                  <label *ngIf="projection.projectionName == 'State Personal Tax Projection'" class="user-title title-adjust">Q4 Due 12/15</label>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter4.recommended | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter4.paid | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter4.paidDate}}</span>
                </div>
                <div class="column medium-3">
                  <span>{{projection.quarter4.notes}}</span>
                </div>
              </div>
            </div>
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-3">
                  <label class="user-title title-adjust">Additional Payment1</label>
                </div>
                <div class="column medium-2">
                  <span>{{projection.addittionalPayment1.recommended | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.addittionalPayment1.paid | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.addittionalPayment1.paidDate}}</span>
                </div>
                <div class="column medium-3">
                  <span>{{projection.addittionalPayment1.notes}}</span>
                </div>
              </div>
            </div>
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-3">
                  <label class="user-title title-adjust">Additional Payment2</label>
                </div>
                <div class="column medium-2">
                  <span>{{projection.addittionalPayment2.recommended | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.addittionalPayment2.paid | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.addittionalPayment2.paidDate}}</span>
                </div>
                <div class="column medium-3">
                  <span>{{projection.addittionalPayment2.notes}}</span>
                </div>
              </div>
            </div>
            <div class="column medium-12" style="margin-top: 5px;">
              <div class="row">
                <div class="column medium-3">
                  <span class="bold">Total Estimates</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.recommendedEstimates  | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.paidEstimates  | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                </div>
                <div class="column medium-3">
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template [ngIf]="projection.projectionName == 'C-Corp Federal Tax Projection' || projection.projectionName == 'C-Corp State Tax Projection'">
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-2">
                  <label class="user-title title-adjust">Q1</label>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter1.dueDate}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter1.recommended | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter1.paid | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter1.paidDate}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter1.notes}}</span>
                </div>
              </div>
            </div>
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-2">
                  <label class="user-title title-adjust">Q2</label>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter2.dueDate}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter2.recommended | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter2.paid | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter2.paidDate}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter2.notes}}</span>
                </div>
              </div>
            </div>
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-2">
                  <label class="user-title title-adjust">Q3</label>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter3.dueDate}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter3.recommended | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter3.paid | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter3.paidDate}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter3.notes}}</span>
                </div>
              </div>
            </div>
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-2">
                  <label class="user-title title-adjust">Q4</label>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter4.dueDate}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter4.recommended | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter4.paid | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter4.paidDate}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.quarter4.notes}}</span>
                </div>
              </div>
            </div>
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-2">
                  <label class="user-title title-adjust">Additional Payment1</label>
                </div>
                <div class="column medium-2">
                  <span>{{projection.addittionalPayment1.dueDate}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.addittionalPayment1.recommended | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.addittionalPayment1.paid | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.addittionalPayment1.paidDate}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.addittionalPayment1.notes}}</span>
                </div>
              </div>
            </div>
            <div class="column medium-12">
              <div class="row">
                <div class="column medium-2">
                  <label class="user-title title-adjust">Additional Payment2</label>
                </div>
                <div class="column medium-2">
                  <span>{{projection.addittionalPayment2.dueDate}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.addittionalPayment2.recommended | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.addittionalPayment2.paid | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.addittionalPayment2.paidDate}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.addittionalPayment2.notes}}</span>
                </div>
              </div>
            </div>
            <div class="column medium-12" style="margin-top: 5px;">
              <div class="row">
                <div class="column medium-2">
                  <span class="bold">Total Estimates</span>
                </div>
                <div class="column medium-2"></div>
                <div class="column medium-2">
                  <span>{{projection.recommendedEstimates  | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2">
                  <span>{{projection.paidEstimates  | formatAmount:'$0,0'}}</span>
                </div>
                <div class="column medium-2"></div>
                <div class="column medium-2"></div>
              </div>
            </div>
          </ng-template>
          <div class="column medium-12" style="margin-top: 15px;">
            <div class="row">
              <div class="column medium-3">
                <span class="bold">Remainder Due/Refund</span>
              </div>
              <div class="column medium-2">
                <span *ngIf="projection.isRemainderDueOrRefundNegative">({{projection.remainderDueRefund  | formatAmount:'$0,0'}})</span>
                <span *ngIf="!projection.isRemainderDueOrRefundNegative">{{projection.remainderDueRefund  | formatAmount:'$0,0'}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row" *ngIf="publishedPlans && publishedPlans.length == 0">
  <div class="medium-12 columns">
    <div class="text-align-center" style="margin-left: 10px; color: #878787;">No published plans available for tax estimates.</div>
  </div>
</div>

<div id="customer-tax-estimate-projection" style="display: none;">
  <table style="font-size: 15px; margin-top: 30px; width: 100%;">
    <thead style="background: none;">
    <tr style="height: 50px;">
      <th style="text-align: center;" [ngStyle]="{'background-color': backgroundColor}">
        ````
      </th>
    </tr>

    <tr style="height: 36px;">
      <th style="text-align: center;font-size: 25px;color: #16477a;">
        Tax Estimates
      </th>
    </tr>
    <tr style="height: 36px;">
      <th style="text-align: center;font-size: 20px;color: #16477a;">
        {{userName || ''}}
      </th>
    </tr>
    <tr style="height: 36px;" *ngIf="selectedPlan && selectedPlan.planName">
      <th style="text-align: center;font-size: 18px;color: #16477a;">
        {{selectedPlan.planName || ''}}
      </th>
    </tr>
    <tr style="height: 36px;">
      <th style="text-align: center;font-size: 18px;color: #16477a;">
        {{exportedDate || ''}}
      </th>
    </tr>
    <tr style="height: 20px;">
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td>
        <table style="width: 100%;">
          <thead>
          <tr>
            <th></th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr style="height: 36px;">
            <td>Prior Year Tax</td>
            <td style="padding-left: 20px;">{{taxEstimates.priorYearTax | formatAmount:'$0,0'}}</td>
          </tr>
          <tr style="height: 36px;">
            <td>Prior Year Tax AGI</td>
            <td style="padding-left: 20px;">{{taxEstimates.priorYearAGI | formatAmount:'$0,0'}}</td>
          </tr>
          <tr style="height: 36px;">
            <td>Current Year Estimated Tax</td>
            <td style="padding-left: 20px;">{{taxEstimates.currentYearTax | formatAmount:'$0,0'}}</td>
          </tr>
          <tr style="height: 36px;">
            <td>Current Year Estimated Tax AGI</td>
            <td style="padding-left: 20px;">{{taxEstimates.currentYearAGI | formatAmount:'$0,0'}}</td>
          </tr>
          <tr style="height: 36px;">
            <td>Filing Status</td>
            <td style="padding-left: 20px;">{{taxEstimates.filingStatus}}</td>
          </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <ng-template style="height: 36px;" ngFor [ngForOf]="projections" let-projection="$implicit" let-i="index">
      <tr style="height: 20px;">
        <td></td>
      </tr>
      <tr style="height: 20px;">
        <td style="color: #16477a; font-size: 18px;font-weight: bold;">{{projection.projectionName}}</td>
      </tr>
      <tr>
        <td>
          <table style="width: 70%;">
            <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <ng-template [ngIf]="projection.projectionName == 'Federal 1040 Tax Projection' || projection.projectionName == 'State Personal Tax Projection'">
              <tr style="height: 36px;" *ngIf="projection.projectionName == 'Federal 1040 Tax Projection'">
                <td>Safe Harbor Tax Due</td>
                <td style="padding-left: 20px;">{{projection.safeHarbor | formatAmount:'$0,0'}}</td>
              </tr>
              <tr style="height: 36px;" *ngIf="projection.projectionName == 'State Personal Tax Projection'">
                <td>Prior Year Tax Due</td>
                <td style="padding-left: 20px;">{{projection.priorYearTaxDue | formatAmount:'$0,0'}}</td>
              </tr>
              <tr style="height: 36px;" *ngIf="projection.projectionName == 'Federal 1040 Tax Projection'">
                <td>Current Year Expected Minimum Tax Due</td>
                <td style="padding-left: 20px;">{{projection.currentYearExpectedMinTaxDue | formatAmount:'$0,0'}}</td>
              </tr>
            </ng-template>
            <ng-template [ngIf]="projection.projectionName != 'Federal 1040 Tax Projection'">
              <tr style="height: 36px;">
                <td>Current Year Expected Tax Due</td>
                <td style="padding-left: 20px;">{{projection.currentYearExpectedMinTaxDue | formatAmount:'$0,0'}}</td>
              </tr>
            </ng-template>
            <ng-template [ngIf]="projection.projectionName == 'Federal 1040 Tax Projection' || projection.projectionName == 'State Personal Tax Projection'">
              <tr style="height: 36px;">
                <td>Minimum Amount Due to IRS</td>
                <td style="padding-left: 20px;">{{projection.minimumAmountDueToIRS | formatAmount:'$0,0'}}</td>
              </tr>
            </ng-template>
            <tr style="height: 36px;">
              <td>Over Payment Applied for PY</td>
              <td style="padding-left: 20px;">{{projection.overPaymentAppliedForPY | formatAmount:'$0,0'}}</td>
            </tr>
            <ng-template [ngIf]="projection.projectionName == 'Federal 1040 Tax Projection' || projection.projectionName == 'State Personal Tax Projection'">
              <tr style="height: 36px;">
                <td>Estimated W-2 Withholding</td>
                <td style="padding-left: 20px;">{{projection.estimatedW2WithHolding | formatAmount:'$0,0'}}</td>
              </tr>
            </ng-template>
            <tr style="height: 36px;">
              <td>Note to client</td>
              <td style="padding-left: 20px;width: 150px;">{{projection.notes}}</td>
            </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td>
          <table style="width: 100%;">
            <thead>
            <ng-template [ngIf]="projection.projectionName == 'Federal 1040 Tax Projection' || projection.projectionName == 'State Personal Tax Projection'">
              <tr style="height: 36px;color: #878787;background-color: #E5E5E5;padding: 5px 0;">
                <th></th>
                <th style="text-align: center;">Recommended</th>
                <th style="text-align: center;">Paid</th>
                <th style="text-align: center;">Paid Date</th>
                <th style="text-align: center;">Notes</th>
              </tr>
            </ng-template>
            <ng-template [ngIf]="projection.projectionName == 'C-Corp Federal Tax Projection' || projection.projectionName == 'C-Corp State Tax Projection'">
              <tr style="height: 36px;color: #878787;background-color: #E5E5E5;padding: 5px 0;">
                <th></th>
                <th style="text-align: center;">Due Date</th>
                <th style="text-align: center;">Recommended</th>
                <th style="text-align: center;">Paid</th>
                <th style="text-align: center;">Paid Date</th>
                <th style="text-align: center;">Notes</th>
              </tr>
            </ng-template>
            </thead>
            <tbody>
            <ng-template [ngIf]="projection.projectionName == 'Federal 1040 Tax Projection' || projection.projectionName == 'State Personal Tax Projection'">
              <tr style="height: 36px;">
                <td>Q1 Due 4/15</td>
                <td style="text-align: center;">{{projection.quarter1.recommended | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.quarter1.paid | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.quarter1.paidDate}}</td>
                <td style="text-align: center;width: 130px;">{{projection.quarter1.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Q2 Due 6/15</td>
                <td style="text-align: center;">{{projection.quarter2.recommended | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.quarter2.paid | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.quarter2.paidDate}}</td>
                <td style="text-align: center;width: 130px;">{{projection.quarter2.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Q3 Due 9/15</td>
                <td style="text-align: center;">{{projection.quarter3.recommended | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.quarter3.paid | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.quarter3.paidDate}}</td>
                <td style="text-align: center;width: 130px;">{{projection.quarter3.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td *ngIf="projection.projectionName == 'Federal 1040 Tax Projection'">Q4 Due 1/15</td>
                <td *ngIf="projection.projectionName == 'State Personal Tax Projection'">Q4 Due 12/15</td>
                <td style="text-align: center;">{{projection.quarter4.recommended | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.quarter4.paid | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.quarter4.paidDate}}</td>
                <td style="text-align: center;width: 130px;">{{projection.quarter4.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Additional Payment1</td>
                <td style="text-align: center;">{{projection.addittionalPayment1.recommended | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.addittionalPayment1.paid | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.addittionalPayment1.paidDate}}</td>
                <td style="text-align: center;width: 130px;">{{projection.addittionalPayment1.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Additional Payment2</td>
                <td style="text-align: center;">{{projection.addittionalPayment2.recommended | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.addittionalPayment2.paid | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.addittionalPayment2.paidDate}}</td>
                <td style="text-align: center;width: 130px;">{{projection.addittionalPayment2.notes}}</td>
              </tr>
              <tr style="height: 36px;font-weight: bold;">
                <td>Total Estimates</td>
                <td style="text-align: center;">{{projection.recommendedEstimates | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.paidEstimates | formatAmount:'$0,0'}}</td>
                <td></td>
                <td></td>
              </tr>
              <tr style="height: 36px;font-weight: bold;">
                <td>Remainder Due/Refund</td>
                <td style="text-align: center;" *ngIf="projection.isRemainderDueOrRefundNegative">({{projection.remainderDueRefund  | formatAmount:'$0,0'}})</td>
                <td style="text-align: center;" *ngIf="!projection.isRemainderDueOrRefundNegative">{{projection.remainderDueRefund  | formatAmount:'$0,0'}}</td>
                <td></td>
                <td></td>
              </tr>
            </ng-template>
            <ng-template [ngIf]="projection.projectionName == 'C-Corp Federal Tax Projection' || projection.projectionName == 'C-Corp State Tax Projection'">
              <tr style="height: 36px;">
                <td>Q1</td>
                <td style="text-align: center;">{{projection.quarter1.dueDate}}</td>
                <td style="text-align: center;">{{projection.quarter1.recommended | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.quarter1.paid | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.quarter1.paidDate}}</td>
                <td style="text-align: center;width: 130px;">{{projection.quarter1.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Q2</td>
                <td style="text-align: center;">{{projection.quarter2.dueDate}}</td>
                <td style="text-align: center;">{{projection.quarter2.recommended | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.quarter2.paid | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.quarter2.paidDate}}</td>
                <td style="text-align: center;width: 130px;">{{projection.quarter2.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Q3</td>
                <td style="text-align: center;">{{projection.quarter3.dueDate}}</td>
                <td style="text-align: center;">{{projection.quarter3.recommended | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.quarter3.paid | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.quarter3.paidDate}}</td>
                <td style="text-align: center;width: 130px;">{{projection.quarter3.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Q4</td>
                <td style="text-align: center;">{{projection.quarter4.dueDate}}</td>
                <td style="text-align: center;">{{projection.quarter4.recommended | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.quarter4.paid | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.quarter4.paidDate}}</td>
                <td style="text-align: center;width: 130px;">{{projection.quarter4.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Additional Payment1</td>
                <td style="text-align: center;">{{projection.addittionalPayment1.dueDate}}</td>
                <td style="text-align: center;">{{projection.addittionalPayment1.recommended | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.addittionalPayment1.paid | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.addittionalPayment1.paidDate}}</td>
                <td style="text-align: center;width: 130px;">{{projection.addittionalPayment1.notes}}</td>
              </tr>
              <tr style="height: 36px;">
                <td>Additional Payment2</td>
                <td style="text-align: center;">{{projection.addittionalPayment2.dueDate}}</td>
                <td style="text-align: center;">{{projection.addittionalPayment2.recommended | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.addittionalPayment2.paid | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.addittionalPayment2.paidDate}}</td>
                <td style="text-align: center;width: 130px;">{{projection.addittionalPayment2.notes}}</td>
              </tr>
              <tr style="height: 36px;font-weight: bold;">
                <td>Total Estimates</td>
                <td></td>
                <td style="text-align: center;">{{projection.recommendedEstimates | formatAmount:'$0,0'}}</td>
                <td style="text-align: center;">{{projection.paidEstimates | formatAmount:'$0,0'}}</td>
                <td></td>
                <td></td>
              </tr>
              <tr style="height: 36px;font-weight: bold;">
                <td>Remainder Due/Refund</td>
                <td></td>
                <td style="text-align: center;" *ngIf="projection.isRemainderDueOrRefundNegative">({{projection.remainderDueRefund  | formatAmount:'$0,0'}})</td>
                <td style="text-align: center;" *ngIf="!projection.isRemainderDueOrRefundNegative">{{projection.remainderDueRefund  | formatAmount:'$0,0'}}</td>
                <td></td>
                <td></td>
              </tr>
            </ng-template>
            </tbody>
          </table>
        </td>
      </tr>
    </ng-template>
    </tbody>
  </table>
</div>
